import React, { Component } from 'react';
import Logo from '../../images/logo.png';
import {Link} from 'react-router-dom'
import AnniversaryLogo from '../../images/10th_anniversary.png';

class Footer extends Component {
    render() {
        return (
            <div className="footer-area text-center">
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 999,
                    width: '140px',
                    height: 'auto'
                }}>
                    <img 

                        src={AnniversaryLogo} 
                        alt="10. Yıl" 
                        style={{
                            width: '100%',
                            height: 'auto'
                        }}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-image">
                                <Link to="/home">
                                    <img src={Logo} alt=""/>
                                </Link>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-menu">
                                <div className="footer-menu">
                                    <ul>
                                        <li>
                                            <a 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                href="https://facebook.com/alzaturkiye"
                                            >
                                                <i className="fa fa-facebook"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                href="https://x.com/alza_turkiye"
                                            >
                                                <i className="fa fa-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                href="https://instagram.com/alza_turkiye"
                                            >
                                                <i className="fa fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                href="https://youtube.com/alza_turkiye"
                                            >
                                                <i className="fa fa-youtube"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="footer-sub">
                                <p><i className="fa fa-copyright"></i> <span> 2025 ALZA. Tüm hakları saklıdır.</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;